import { useQuery } from "@tanstack/react-query";
import { getApiCodelistManagementDownloadConfigs } from "Infrastructure/Api/Api";

export const DOWNLOAD_CONFIGS_QUERY_KEY = "DOWNLOAD_CONFIGS_QUERY";

export function useDownloadConfigsQuery(
	enabled?: boolean | null,
	offset?: number | null,
	limit?: number | null,
) {
	return useQuery({
		queryKey: [DOWNLOAD_CONFIGS_QUERY_KEY, enabled, offset, limit],
		queryFn: () =>
			getApiCodelistManagementDownloadConfigs(
				enabled,
				offset ?? undefined,
				limit ?? undefined,
			),
	});
}
